import { LogicContext } from '../types';
import { controllersEnum } from '../../controllers';
import {
  GameMode,
  PortalVerticalGameTilePropTypes,
} from '../../../types/gameTypes';

const getGameLaunchUrl = (
  game: PortalVerticalGameTilePropTypes,
  gameMode?: GameMode
) => (gameMode === GameMode.Practice && game.practiceUrl) || game.launchUrl;

export const setGameToLaunchData = async (
  context: LogicContext,
  event: {
    payload?: { game: PortalVerticalGameTilePropTypes; gameMode?: GameMode };
    data?: { game: PortalVerticalGameTilePropTypes; gameMode?: GameMode };
  }
) => {
  const payload = event.payload || event.data;
  const gameMode = payload?.gameMode;

  if (payload && payload.game) {
    const game = payload.game;
    return {
      gameToLaunch: {
        triggeredByUser: !!event.payload,
        ...payload.game,
        modeLaunchUrl: getGameLaunchUrl(game, gameMode),
      },
    };
  }
  const gameLauncher =
    context.controllersData[controllersEnum.GAME_LAUNCHER] &&
    context.controllersData[controllersEnum.GAME_LAUNCHER]!.components.find(
      ([key, entry]) => key === 'GameLauncher'
    );

  const game = {
    ...(!!gameLauncher && {
      ...gameLauncher[1].properties.game,
    }),
  };

  return {
    gameToLaunch: {
      triggeredByUser: false,
      ...game,
      modeLaunchUrl: getGameLaunchUrl(game, gameMode),
    },
  };
};
